/**
 * Beaute Plus — Community UGC Carousel
 *  - Autoplay video on view (muted), pause off-view (IntersectionObserver)
 *  - Mute toggle button per card
 *  - Prev / Next nav buttons (desktop)
 *  - Add-to-cart AJAX (with fallback to native form post)
 */
(function () {
  function initCard(card) {
    const video = card.querySelector('video.bp-ugc-card__video');
    const muteBtn = card.querySelector('[data-bp-ugc-mute]');
    const muteOff = card.querySelector('.bp-ugc-card__mute-icon--off');
    const muteOn = card.querySelector('.bp-ugc-card__mute-icon--on');
    const form = card.querySelector('[data-bp-ugc-form]');

    if (video) {
      // Autoplay on view
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.5] }
      );
      observer.observe(video);
    }

    if (muteBtn && video) {
      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        if (video.muted) {
          muteOff && muteOff.removeAttribute('hidden');
          muteOn && muteOn.setAttribute('hidden', '');
        } else {
          muteOff && muteOff.setAttribute('hidden', '');
          muteOn && muteOn.removeAttribute('hidden');
        }
      });
    }

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('.bp-ugc-card__cta');
        const originalText = btn ? btn.textContent : '';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding...';
        }
        try {
          const formData = new FormData(form);
          const res = await fetch(form.action, {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/javascript' },
          });
          if (!res.ok) throw new Error('add failed');
          if (btn) btn.textContent = 'Added ✓';

          // Try to update cart UI (Dawn's cart drawer / cart count)
          // Dispatch event so theme cart components can refresh.
          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
          // Open cart-notification if present (Dawn)
          const cartNotification = document.querySelector('cart-notification');
          if (cartNotification && typeof cartNotification.open === 'function') {
            cartNotification.open();
          }

          setTimeout(() => {
            if (btn) {
              btn.textContent = originalText;
              btn.disabled = false;
            }
          }, 1600);
        } catch (err) {
          if (btn) {
            btn.textContent = 'Error — try again';
            btn.disabled = false;
            setTimeout(() => {
              btn.textContent = originalText;
            }, 1800);
          }
        }
      });
    }
  }

  function initCarousel(carousel) {
    if (carousel.dataset.bpUgcInit === '1') return;
    carousel.dataset.bpUgcInit = '1';

    carousel.querySelectorAll('.bp-ugc-card').forEach(initCard);

    const section = carousel.closest('.beauteplus-community-ugc');
    const prevBtn = section && section.querySelector('[data-bp-ugc-prev]');
    const nextBtn = section && section.querySelector('[data-bp-ugc-next]');

    function getStep() {
      const card = carousel.querySelector('.bp-ugc-card');
      if (!card) return 320;
      const styles = getComputedStyle(carousel);
      const gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    function updateNavState() {
      const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      if (prevBtn) prevBtn.toggleAttribute('disabled', carousel.scrollLeft <= 4);
      if (nextBtn) nextBtn.toggleAttribute('disabled', carousel.scrollLeft >= maxScroll - 4);
    }
    carousel.addEventListener('scroll', updateNavState, { passive: true });
    requestAnimationFrame(updateNavState);
    window.addEventListener('resize', updateNavState, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('[data-bp-ugc-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
